import {Controller} from "stimulus";

export default class extends Controller {

    connect() {
        this.element.addEventListener('click', this.onClick);
    }

    onClick(event) {
        event.preventDefault();
        navigator.clipboard.writeText(this.dataset.url);
        $('body').addClass('copied-to-clipboard')
        setTimeout(() => {
            $('body').removeClass('copied-to-clipboard')
        }, 2500);
    }
}
